<template>
    <div>
        <residential-canteen-addresses-form :entity-id="entityId">
        </residential-canteen-addresses-form>
    </div>
</template>

<script>
import residentialCanteenAddressesForm from '@/components/pages/residentialCanteens/addresses/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        residentialCanteenAddressesForm,
    },
    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.entityId
            },
        },
    },
}
</script>
